export default __webpack_public_path__ + "static/media/nodejs.e2573262.svg";